// extracted by mini-css-extract-plugin
export var actionText = "_km-4";
export var container = "_km-0";
export var leftSection = "_km-1";
export var rightSection = "_km-2";
export var settingsButton = "_km-6";
export var settingsIcon = "_km-7";
export var shortcut = "_km-5";
export var shortcutGroup = "_km-3";